import FileIconWrapper from './FileIconWrapper';
import { FileIcon as FileIconBase } from 'react-file-icon';
import { grey } from '@mui/material/colors';

const UnknownFileIcon = () => (
  <FileIconWrapper>
    <FileIconBase extension="?" type="binary" color={grey[400]} />
  </FileIconWrapper>
);

export default UnknownFileIcon;
